import Model from 'src/app/core/models/model';

export default class ItemTypesModel extends Model {
  name: string;
  description?: string;

  constructor() {
    super();
  }
}
